import axios from 'axios'
const { getBaseClientAccountApiURL } = require('./helpers/baseurl')

export const baseURL = getBaseClientAccountApiURL()

export default axios.create({
  baseURL: baseURL
});

